import React from "react";
import "../../index.css";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import card_config from "../../gpap-lib/StartCard/card_config";
import StartCard from "../../gpap-lib/StartCard/StartCard";
import MANAGEMENT_LOGO from "../../gpap-lib/img/management.svg";

import "./home.css";

function Home(props) {
  const getCards = () => card_config.map((item) => (
    <Grid key={item} item lg={3}>
      <StartCard item={item} />
    </Grid>
  ));

  return (
    <React.Fragment>
      <div className="home">
        <div className={"home_title"}>
          <Typography variant={"h4"}>
            Welcome to 3TR Data Submission & Management App
          </Typography>
          <Typography variant={"h5"}>
            {" "}
            Submit, Browse and share datasets
          </Typography>
        </div>
        <h5>
          <img
            src={MANAGEMENT_LOGO}
            id="logo"
            alt="PhenoStoreApp Start"
            style={{ width: "9%", marginBottom: "42px" }}
          />
        </h5>

        <p id="home_p1">
          {" "}
          This is the beta version of the new 3TR-Data Management Module. You
          can create a new dataset and upload files as well as explore your
          submissions.
        </p>
        <hr className="divider" />
        <Typography variant={"h4"}>Where you can start from</Typography>
        <div className="boxStart">
          <Grid container justify="center" spacing={2}>
            {getCards()}
          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Home;
